/**
 * URL utility functions
 */

/**
 * Resolve an asset path to a full URL.
 * Returns the path unchanged if it's already an absolute URL (http/https),
 * otherwise joins it to REACT_APP_IMAGE_BASE_URL with exactly one slash.
 *
 * Special case: paths that start with `/images/` are app-owned public
 * assets (bundled aircraft photos, static UI images). They live at the
 * SAME origin as the running page — not on the API host — so we
 * resolve them against window.location.origin. This matters because
 * REACT_APP_IMAGE_BASE_URL carries the API port (e.g. dev.trustjet.ai:8000),
 * which would 404 for public-folder assets served from the app origin
 * (dev.trustjet.ai, no port).
 *
 * @param {string} path - Asset path or full URL
 * @returns {string} Resolved URL (empty string if path is falsy)
 */
export function resolveAssetUrl(path) {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith('/images/')) {
    return `${typeof window !== 'undefined' ? window.location.origin : ''}${path}`;
  }
  const base = process.env.REACT_APP_IMAGE_BASE_URL || '';
  if (!base) return path;
  const baseTrimmed = base.endsWith('/') ? base.slice(0, -1) : base;
  const pathPrefixed = path.startsWith('/') ? path : `/${path}`;
  return `${baseTrimmed}${pathPrefixed}`;
}
